import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { usersQueryKeys } from '../data';

export const useResetUserInfo = () => {
  const queryClient = useQueryClient();

  const resetUserInfo = useCallback(async () => {
    void (await queryClient.invalidateQueries({
      queryKey: usersQueryKeys.getUserInfo,
    }));
  }, [queryClient]);

  return resetUserInfo;
};
